import React, { Component } from 'react';
import { connect } from 'react-redux';
import './PaymentSuperFund.css';
import { getAdjustDetail ,getredeemToSuperFundPreview,getredeemToSuperFund,getvalidateRedeemToSuperFund,isInvestmentFlag,getHistoryAdjust,superFundPunishmentIn7Day} from '../action/investmentAction.js';
import Util from '../util';
import {getStorage} from '../common';
import 'echarts/lib/chart/pie';
import echarts from 'echarts/lib/echarts';
import { hashHistory } from 'react-router';
import NavigatorMain from './NavigatorMain';
import { Toast } from 'antd-mobile/lib';
import {ModalTips,AlerModleCommon} from '../components/fundDetail/AlerModle'
import ModalPaySup from '../components/Modal/ModalPaySup';
import {getStrategiesDetailsHaveCast}from '../action/portfolioAction'
let width = window.screen.width 
class TransferF extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pwdFlag:false,  
      transferVal:'',
      transferFlag:false,
      text:'',
      isShowModal: false,
      data:[],
      isShowModal2:false,
      hideContent: false,
      sevenDayFlag:false,
      supRiskVal: ""

    };
    this.userMsg={nickName:null,mobileNo:null,name:null}
  }
  componentWillMount(){
    let {dispatch}=this.props
    this.getUserMsg()
    // if (this.props.location.state.type===1) {
    //   document.title = "调整组合"
    //   dispatch(getAdjustDetail({superFundCode:this.props.location.state.superFundCode},(result)=>this.transferFlag(result)));
    // }else{
    //   document.title = "季度调仓"
    //   dispatch(getSeasonDetail({superFundCode:this.props.location.state.superFundCode}));
    // }
    let { superFundCode,amount,targetFundList }  = this.props.location.state;
    console.log(superFundCode,amount,targetFundList)
    dispatch(getredeemToSuperFundPreview({
      superFundCode,
      amount,
      targetSuperFundCode:targetFundList[this.props.targetIndex].superFundCode
    }))

  }
  componentDidMount(){
    let { superFundCode }  = this.props.location.state;
    this.hasInvested();
    this.props.dispatch(getStrategiesDetailsHaveCast({
      superFundCode
    }, ()=>{}));
  }
  hasInvested(){
    console.log(111)
  this.props.dispatch(isInvestmentFlag({superFundCode:this.props.location.state.fundCode},(result, riskLevel)=>{
    if(!result){
      const sess = sessionStorage.getItem("modalShowByTip");
      if(sess) {
        let arr = sess.split(",");
        if(arr.indexOf("zh_zt") < 0) {
          this.setState({
            isShowModal:true,
            hideContent: true,
            supRiskVal: this.returnLevelFun(riskLevel)
          });
        } 
      }else {
        this.setState({
          isShowModal:true,
          hideContent: true,
          supRiskVal: this.returnLevelFun(riskLevel)
        });
      }
    }
  }))
  }
  returnLevelFun = (val) => {
    if(val == "2") {
      return "R2";
    }
    if(val == "3") {
      return "R3";
    }
    if(val == "4") {
      return "R4";
    }
    return "";
  }
  getUserMsg(){
     this.userMsg=JSON.parse(localStorage.currentUserInfo).userMsg;
     console.log(this.userMsg)
  }
  
  transferFlag(result){
    this.setState({
      transferVal:result.code,
      transferFlag:true,
    })

  }
  succallback(){
    // alert()
  }
  errcallback(msg){
    // alert(msg)
  }
  showKeyboard(){
    const { 
      dispatch,
      strategiesDetails
    }=this.props;
    let { superFundCode,amount,targetFundList }  = this.props.location.state;
    let data={amount,targetSuperFundCode:targetFundList[this.props.targetIndex].superFundCode,superFundCode}
    //判断七日惩罚性赎回
    let params = {
      fundCode: superFundCode,
      businessType: 'T036',
      trustChannelId: targetFundList[this.props.targetIndex].trustChannelId
    }
    dispatch(superFundPunishmentIn7Day(params,(result)=>{
      console.log(result)
      if(result.content){
        this.setState({
          sevenDayFlag: true
        })
      }else{
        dispatch(getvalidateRedeemToSuperFund(data,(res)=>{
          if (this.state.transferVal=='') {
            //组合成分基金中包含华夏基金产品，需弹窗提示
        dispatch(getHistoryAdjust({superFundCode:targetFundList[this.props.targetIndex].superFundCode},(result)=>{
          let data = result[result.length - 1].itemAdjustList;
          let fundsArr = [];
          console.log(data);
          for (let i = 0; i< data.length; i++) {
                if(data[i].fundName.indexOf('华夏')!= -1){
                  fundsArr.push(data[i].fundName)
                  }
              }
              if (fundsArr.length == 0) {
                console.log(1)
                this.setState({
               pwdFlag:true
                })
              } else {
                console.log(2)
                this.setState({
                  data:fundsArr.join('、'),
                  isShowModal2:true
                })  
              }
            }))
            // this.setState({
            //   pwdFlag:true
            // })
          }else{
            Toast.info(this.state.transferVal, 2);
          }
        }))
      }
    }))
  }
  //七日赎回确认
  onNext(){
    const { 
      dispatch,
    }=this.props;
    let { superFundCode,amount,targetFundList }  = this.props.location.state;
    let data={amount,targetSuperFundCode:targetFundList[this.props.targetIndex].superFundCode,superFundCode}
    this.setState({
      sevenDayFlag: false
    },()=>{
      dispatch(getvalidateRedeemToSuperFund(data,(res)=>{
        if (this.state.transferVal=='') {
          //组合成分基金中包含华夏基金产品，需弹窗提示
      dispatch(getHistoryAdjust({superFundCode:targetFundList[this.props.targetIndex].superFundCode},(result)=>{
        let data = result[result.length - 1].itemAdjustList;
        let fundsArr = [];
        console.log(data);
        for (let i = 0; i< data.length; i++) {
              if(data[i].fundName.indexOf('华夏')!= -1){
                fundsArr.push(data[i].fundName)
                }
            }
            if (fundsArr.length == 0) {
              console.log(1)
              this.setState({
             pwdFlag:true
              })
            } else {
              console.log(2)
              this.setState({
                data:fundsArr.join('、'),
                isShowModal2:true
              })  
            }
          }))
          // this.setState({
          //   pwdFlag:true
          // })
        }else{
          Toast.info(this.state.transferVal, 2);
        }
      }))
    })
  }
  onChangePwd(val){
    this.setState({
      text:val
    })
  }
  transfer(type){
    let _this=this;
    const pushResult = (i,result) => {
      if (i==1) {
          hashHistory.push({
            pathname:'/Success',
            state: {
              title:'调仓申请结果',
              content:'您的组合转换已被受理！',
              dataSouse:[['申请编号',result.content.tradeRequestIds],['下单时间',Util.returnDate(result.content.businessTime,true)],['所属交易日',Util.returnDate(result.content.requestWorkday)]],
              souseVal:['返回华夏智投']
            }
          });
      } else if (i==3) {
          hashHistory.push({
            pathname:'/ErrorResult',
            state: {
              title:'调仓申请结果',
              content:'很抱歉，您的组合转换申请失败！',
              content2:result,
              dataSouse:[],
              souseVal:['返回华夏智投','联系客服']
            }
          });
      }
    } 
    let { superFundCode,amount,targetFundList }  = this.props.location.state;
    let data={
      amount,
      targetSuperFundCode:targetFundList[this.props.targetIndex].superFundCode,
      flag:1,superFundCode,password:Util.encrypt(this.state.text)
    }
    // this.props.dispatch(getUpdateSeason(date,pushResult))
    this.props.dispatch(getredeemToSuperFund(data,pushResult))
  }
  btnCallBack1(){

  }
  handleOk(){
    this.setState({
      isShowModal:false,
      hideContent: false
    });
    const sess = sessionStorage.getItem("modalShowByTip");
    if(sess) {
      let arr = sess.split(",");
      if(arr.indexOf("zh_zt") < 0) {
        arr.push("zh_zt");
        sessionStorage.setItem("modalShowByTip", arr.join());
      } 
    }else {
      sessionStorage.setItem("modalShowByTip", "zh_zt");
    }
  }
  onOk(){
    this.setState({
      isShowModal2:false,
      pwdFlag:true
    })
  }
  chooseIndex(){
    let { targetFundList }  = this.props.location.state;
    hashHistory.push({
      pathname: "/TargetFundsList",
      query:{
        dataSouse:targetFundList
      },
      state: {
        dataSouse:targetFundList
        
      }
    });
  }
  render(){
    console.log(this.props.location.state)
    let {type,superFundCode,isZJ}=this.props.location.state;
    const {inSeasonDetail,redeemToSuperFundPreview}=this.props;
    console.log(inSeasonDetail.previewItemFundsChart,'------',redeemToSuperFundPreview)
    let pieImg = "";
    let name=''
    let _img = Util.superFundTextArr(superFundCode, "TransferF")[1];
    pieImg = require("../img/" + _img);
    name = Util.superFundTextArr(superFundCode, "TransferF")[0];
    let { targetFundList }  = this.props.location.state;
    // console.log(targetFundList);
    return (
        <div className="container" >
          <div style={{display: this.state.hideContent ? "none" : "block"}}>
            <NavigatorMain>
              <div className="header">
                <div onClick={hashHistory.goBack}><span className="headerLeftBtn"></span></div>
                <div style={{overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{"转换详情"}</div>
                <div></div>
              </div>
            </NavigatorMain>
            <div style={{WebkitFlex: 1, overflow: "auto"}}>
              <div className='content' style={{paddingBottom:'50px'}}>
                  <div className="listStyle" onClick={()=>this.chooseIndex()}>
                    <div style={{height:44}} className="jus_center">
                      <span style={{fontSize:13,color:"#5b6370"}}>
                      转入组合
                      </span>
                    </div>
                    <div style={{height:44,flexDirection:"row",alignItems:'center'}}>
                      <span>{ targetFundList[this.props.targetIndex].superFundName }</span>
                      <img src={require('../img/arrowGrayRightOne.png')} style={{width:30,height:44}}/>
                    </div>
                  </div>

                  <div style={{display: "-webkit-flex",marginTop:'0.12rem',padding:'0 13px',height:'40px',WebkitAlignItems: 'center'}}>
                    <p style={{fontSize:'12px',color:"#000",WebkitFlex:1}}>{'最新组合配置'}</p>
                    <p className='gary12'>{redeemToSuperFundPreview.superFund.nextAdjustDate?redeemToSuperFundPreview.superFund.nextAdjustDate.substring(0,10)+'更新':'--更新'}</p>
                  </div>
                  {
                    redeemToSuperFundPreview.previewItemFunds.length==0?null:
                    <div style={{background:'#fff',position:'relative', display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center"}}>
                      <img  src={pieImg}  style={{position:'absolute',left:width*0.3-32,width:'64px',height:'64px'}} />
                      <TransferPie inSeasonDetail={redeemToSuperFundPreview}/>
                    </div>
                  }

                  <div style={{padding:'13px'}}>
                      <p style={{}}>调仓明细</p>
                  </div>
                  {
                    redeemToSuperFundPreview.previewItemFunds.map(function (item,i) {
                      return(
                        <div key={'list'+i} style={{display: "-webkit-flex",background:'#fff',height:'0.9rem',padding:'0 13px',borderBottom:'0.005rem solid rgb(224,227,279)'}}>
                          <p className='gary12' style={{WebkitFlex:1,lineHeight:'0.9rem'}}>{item.fundName}</p>
                          <p style={{lineHeight:'0.9rem'}}>{Util.newToFixed(item.holdRate*100)+'%→'+Util.newToFixed(item.targetRegularRate*100)+'%'}</p>
                        </div>
                      )
                    })
                  }
                  <div style={{paddingTop:6}}>
                    <div style={{height:'0.9rem',marginLeft:'13px'}}>
                      <p >预估成本</p>
                    </div>
                  </div>
                  <div style={{display: "-webkit-flex",background:'#fff',height:'0.9rem',padding:'0 13px',borderBottom:'0.005rem solid rgb(224,227,279)'}}>
                    <p className='gary12' style={{fontSize:'12px',WebkitFlex:1,lineHeight:'0.9rem'}}>预计发生费用</p>
                    <p style={{lineHeight:'0.9rem'}}>{ redeemToSuperFundPreview.fee !=null ? Util.formatStr(redeemToSuperFundPreview.fee) + "元" : "--"}</p>
                  </div>
                  <div style={{display: "-webkit-flex",background:'#fff',height:'0.9rem',padding:'0 13px'}}>
                    <p className='gary12' style={{fontSize:'12px',WebkitFlex:1,lineHeight:'0.9rem'}}>预计完成时间</p>
                    <p style={{lineHeight:'0.9rem'}}>{Util.formatStr(redeemToSuperFundPreview.needDays)+'日'}</p>
                  </div>
                  <div style={{display: "-webkit-flex",marginTop:'0.4rem',background:'#fff',padding:'0 13px',WebkitFlexDirection:"column",paddingBottom:10}}>
                   <p className='gary12' style={{marginTop:10}}>温馨提示：</p>
                   <p className='gary12' style={{marginTop:5,fontWeight:"bold"}}>1、本业务暂不支持撤单。</p>
                   <p className='gary12' style={{marginTop:5}}>2、预计成本仅供参考，请以实际发生费用为准。</p>
                  </div>
                  
              </div>
              <div style={{position:'fixed',bottom:0,width:'100%',borderTop:'1px solid rgb(224,227,229)'}}>
                <div style={{color:'#5b6370',display: "-webkit-flex",WebkitAlignItems:'center',overflow:'hidden',border:'1px solid rgb(224,227,279)'}}>
                  <p onClick={()=>this.showKeyboard(type)} style={{color:'#fff',backgroundColor:'#fa063a',textAlign:'center',height:'40px',lineHeight:'40px',WebkitFlex:3}}>确认转换</p>
                </div>
              </div>
              {
                this.state.pwdFlag?
                <div style={{position:'fixed',top:0,width:'100%',height:'100%',background:'rgba(52,52,52,0.4)'}}>
                  <div style={{position:'fixed',bottom:0,width:'100%',height:'70%',background:'#fff'}}>
                    <div style={{position:'relative',height:'0.9rem',lineHeight:'0.9rem',textAlign:'center',borderBottom:'0.005rem solid rgb(224,227,279)'}}>
                      交易密码
                      <img src={require('../img/close.png')}  style={{position:'absolute',left:0,width:'0.88rem',height:'0.88rem'}} onClick={()=>{this.setState({pwdFlag:false})}}/>
                      <span  style={{position:'absolute',top:0,right:0,width:'0.9rem'}} onClick={()=>{this.transfer(type)}}> 确认</span>
                    </div>
                    <div style={{height:'0.9rem',padding:'13px'}}>
                      <input autocomplete="off" onChange={(e)=>this.onChangePwd(e.target.value)}  autofocus="autofocus" style={{height:'0.9rem',width:'100%',fontSize:'0.3rem',border:'1px solid #afafaf',borderRadius:'0.1rem'}} type="password"  placeholder=""/>
                    </div>
                  </div>
                </div>
                :null
              }
              {
                this.state.isShowModal2?
                <ModalPaySup title='利益关联方冲突提示' onOK={()=>{this.onOk()}}  rightButtonTitle='我已知晓' fundName={targetFundList[this.props.targetIndex].superFundName} data={this.state.data} />
                :null
              }
              </div>
            </div>
            {
              this.state.isShowModal?
            <ModalTips title='基金投资顾问业务投资者风险揭示书' buttonText='我已知晓风险，确认购买' handleOk={()=>{ this.handleOk() }} verifiedUserInfo={this.props.verifiedUserInfo.content}/>
            :null
            }
            {
             this.state.sevenDayFlag ?
             <AlerModleCommon 
             btnTxt1="确认"
             btnTxt2="取消"
             content={"自交易日2018年3月30日起，若投资者赎回除货币及交易型开放式指数基金以外的开放式基金时持续持有期少于7日（自然日），将被收取不低于1.5%的赎回费。具体赎回费率请参见产品说明。"} 
             title="特别提示"
             handleClick1 = {()=>{this.onNext()}}
             handleClick2 = {()=>{this.setState({sevenDayFlag:false})} }
           /> : null
           }
        </div>
    );
  }
}
function compare(prop){
    return function (obj1, obj2) {
      var val1 = obj1[prop];
      var val2 = obj2[prop];
      if (!isNaN(Number(val1)) && !isNaN(Number(val2))) {
          val1 = Number(val1);
          val2 = Number(val2);
      }
      if (val1 > val2) {
          return -1;
      } else if (val1 < val2) {
          return 1;
      } else {
          return 0;
      }            
    }
}
class TransferPie extends Component {
  componentDidMount() {
    let {inSeasonDetail}=this.props;
    let dataSouse=[];
    let dataSouseName=[];
    inSeasonDetail.previewItemFundsChart.sort(compare("srcRegularRate"))
    for (var i = 0; i < inSeasonDetail.previewItemFundsChart.length; i++) {
      let item=inSeasonDetail.previewItemFundsChart[i]

      let name=item.styleTypeName+Util.newToFixed(item.srcRegularRate*100)+'%'
      dataSouse.push(
        {value:Util.newToFixed(item.srcRegularRate*100), name:name}
      )
      dataSouseName.push(name)
    }
    let corArr = ['#e85040','#ff7242','#28b7f6','#7290fd','#9bcd65','#ab47bc'];
    if (window.isLess47) {
      var myChart = echarts.init(document.getElementById('TransferPie'));
    }else{
      var myChart = echarts.init(document.getElementById('TransferPie'), null, {renderer: 'svg'});
    }
    // 绘制图表
    myChart.setOption(SuperPieOption(dataSouse,dataSouseName));
  }
  render(){
    
    return(
      <div id="TransferPie" style={{ width:"100%", height:300}}>
         
      </div>
    )
  }
}

/*饼图Option*/
function SuperPieOption(data,dataName){
  let colorArr = [];
  if(dataName){
  dataName.map((item,key)=>{
      if(item.indexOf("跨境权益") != -1){
        colorArr.push("#4729c5")
      }else if(item.indexOf("国内权益") != -1){
        colorArr.push("#e22424")
      }else if(item.indexOf("跨境债券") != -1){
        colorArr.push("#f25a0f")
      }else if(item.indexOf("另类") != -1){
        colorArr.push("#f0d331")
      }else if(item.indexOf("货币") != -1){
        colorArr.push("#23c7e2")
      }else if(item.indexOf("国内债券") != -1){
        colorArr.push("#034ab2")
      }
    })
  }
  let hg = 60;
  if( dataName.length <= 2){
    hg = 20;
  }else if(dataName.length <= 4){
    hg=60;
  }else if(dataName.length <= 6){
    hg=80;
  }else if(dataName.length <= 8){
    hg=100;
  }

  let SuperPieOption = {
      animation: window.isLess47,
      calculable : true,
      legend: {
          y : 'center',
          x: 'left',
          left:width/2 + 40,
          orient:'vertical',
          data:dataName,
          //height:hg,
          itemWidth:14,
          selectedMode:false,
          textStyle:{color:"auto"}
      },
      series : [
          {   
              minAngle:20,
              type:'pie',
              hoverAnimation:false,
              radius : [44, 75],
              center : ['30%', '50%'],
              roseType : 'radius',
              data:data,
            label:{
              normal:{
                show:false
              }
            },
            labelLine:{
              normal:{
                show:false
              }
            },

          }

      ],
      color:colorArr
    };
  return SuperPieOption;
}
function mapStateToProps(state, ownProps) {
  return {
    inSeasonDetail:state.inSeasonDetail,
    redeemToSuperFundPreview:state.redeemToSuperFundPreview,
    targetIndex:state.targetIndex,
    strategiesDetails: state.strategiesDetails,
    verifiedUserInfo: state.verifiedUserInfo
  }
}
export default connect(mapStateToProps)(TransferF);



// WEBPACK FOOTER //
// ./src/components/TransferF.js